module.exports = __webpack_public_path__ + "img/dressing2.38c8dd0e.jpg";